import { useMemo, useState, useCallback } from 'react';
import useUpdateEffect from '../useUpdateEffect';
export default function useControllableValue(props, options) {
  if (props === void 0) {
    props = {};
  }

  if (options === void 0) {
    options = {};
  }

  var _options = options,
      defaultValue = _options.defaultValue,
      _options$defaultValue = _options.defaultValuePropName,
      defaultValuePropName = _options$defaultValue === void 0 ? 'defaultValue' : _options$defaultValue,
      _options$valuePropNam = _options.valuePropName,
      valuePropName = _options$valuePropNam === void 0 ? 'value' : _options$valuePropNam,
      _options$trigger = _options.trigger,
      trigger = _options$trigger === void 0 ? 'onChange' : _options$trigger;
  var value = props[valuePropName];
  var initialValue = useMemo(function () {
    if (valuePropName in props) {
      return value;
    }

    if (defaultValuePropName in props) {
      return props[defaultValuePropName];
    }

    return defaultValue;
  }, []);

  var _useState = useState(initialValue),
      state = _useState[0],
      setState = _useState[1];
  /* init 的时候不用执行了 */


  useUpdateEffect(function () {
    if (valuePropName in props) {
      setState(value);
    }
  }, [value]);
  var handleSetState = useCallback(function (v) {
    if (!(valuePropName in props)) {
      setState(v);
    }

    if (props[trigger]) {
      props[trigger](v);
    }
  }, [props, valuePropName, trigger]);
  return [state, handleSetState];
}